import * as schemaCertifications from './schemas/progressiveCertifications';
import apiClient from './apiClient';
import { ProgressiveCertificationsDataStore } from '../../datastores/ProgressiveCertificationsDataStore';

class ProgressiveCertificationsDataStoreGraphQL
  implements ProgressiveCertificationsDataStore
{
  client = apiClient();

  async getProgressiveCertifications(
    carrer: string,
    prog: string,
    acadPlan: string
  ) {
    try {
      const response = await this.client.query({
        query: schemaCertifications.getProgressiveCertifications,
        variables: { carrer, prog, acadPlan }
      });
      return response?.data?.getProgressiveCertifications;
    } catch (error) {
      throw new Error(
        `Error fetching progressive certifications: ${
          error instanceof Error ? error.message : String(error)
        }`
      );
    }
  }
}

export default ProgressiveCertificationsDataStoreGraphQL;
